// loading-spinner.component.ts
import { Component, Input } from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-separator',
  standalone: true,
  template: `
    <div class="border-b h-1" [class]="color" [ngClass]="{'mt-4': space === 4}"></div>
  `,
  imports: [
    NgClass
  ]
})
export class SeparatorComponent {
  @Input() space: number = 4;
  @Input() color: string = 'border-theme-divider';
}
